import { createContext } from 'react';

export const SelectedCabinBagsContext = createContext({
  response: { data: null, errors: null, loading: false },
  data: {},
  setData: () => null,
});
